import { CommonModule } from "@angular/common";
import { Component, ChangeDetectionStrategy } from "@angular/core";
import { TableViewComponent } from "../table-view.component";
import { TableTileComponent } from "./table-tile/table-tile.component";

@Component({
  selector: "app-table-tile-view",
  imports: [CommonModule, TableTileComponent],
  templateUrl: "./table-tile-view.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./table-tile-view.component.less",
})
export class TableTileViewComponent extends TableViewComponent {
  public override sortColumns(): void {
    if (this.options.layout) {
      const { tile_columns } = this.options.layout;
      this.headers.sort((a, b) => tile_columns.indexOf(a.name) - tile_columns.indexOf(b.name));
      for (const row of this.getAllRows()) {
        row.fields.sort((a, b) => tile_columns.indexOf(a.name) - tile_columns.indexOf(b.name));
      }
    }
  }
}
